// The only reader of import.meta.env; values are loaded and validated by scripts/secrets.mjs.
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  graphqlUrl: import.meta.env.VITE_GRAPHQL_URL,
  appEnv: import.meta.env.VITE_APP_ENV,
};
